import React from "react";
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { ContextMenuProps } from "./ContextMenu.types";
import { List } from "../..";
import { ListItemType } from "../List/List.types";
import cx from 'classnames';
import styles from './ContextMenu.module.scss';

const ContextMenu = <T extends ListItemType>(props: ContextMenuProps<T>) => {
  const { className, 'component-variant': componentVariant, ...restProps } = props;
  
  const variantProps = useBuildVariantProps(
    'context-menu',
    {},
    undefined,
    componentVariant,
  );

  return <div className={cx(styles.contextMenu, className)} {...variantProps}>
    <List 
      className={styles.list}
      {...restProps} 
      align="Vertical"
    />
  </div>;
};

export default ContextMenu;
